// NOTE: Remember to update StatusCode in @/client/services/pages if you change this
export type PageErrorCode = 400 | 404 | 403

export default class PageError extends Error {
  name = 'PageError'

  statusCode: PageErrorCode = 400
}
